import { render, staticRenderFns } from "./CostingForm.vue?vue&type=template&id=162b89b2&scoped=true&"
import script from "./CostingForm.vue?vue&type=script&lang=js&"
export * from "./CostingForm.vue?vue&type=script&lang=js&"
import style0 from "./CostingForm.vue?vue&type=style&index=0&id=162b89b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b89b2",
  null
  
)

export default component.exports